import { Modal } from "components/designV2/modal/modal";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Text } from "components/designV2/text/text";
import { useTranslation } from "react-i18next";
import { ColorV2 } from "config/colors";

interface ProfilePanelDeleteModalProps {
  isOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Handles profile panel delete modal.
 */
export const ProfilePanelDeleteModal = (
  props: ProfilePanelDeleteModalProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      label={t("Staff.ProfilePanelDeleteConfirmTitle")}
      size="compact"
      showCloseButton={false}
      footer={
        <>
          <SecondaryButton
            label={t("General.Cancel")}
            disabled={props.isDeleting}
            onClick={props.onClose}
          />
          <SecondaryButton
            label={t("Staff.ProfilePanelDelete")}
            iconName="v2/trash"
            isLoading={props.isDeleting}
            disabled={props.isDeleting}
            onClick={props.onConfirm}
            styleOverrides={{
              textColor: ColorV2.NegativeRed,
              borderColor: ColorV2.NegativeRed,
              iconColor: ColorV2.NegativeRed,
              hoverBackgroundColor: "#fce9e9",
              activeBackgroundColor: "rgba(211, 78, 78, 0.2)",
            }}
          />
        </>
      }
    >
      <Text typography="b2" color={ColorV2.Blue1} align="left">
        {t("Staff.ProfilePanelDeleteConfirmBody")}
      </Text>
    </Modal>
  );
};
